import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_REGISTER_GST_STATE,
  CLOSE_BSB_NOTICE,
  RESET_TUGO_BANK_FIELDS,
  RESET_ADDRESS,
  FNOL_GET_PAYMENT_CODE_TYPES_SUCCESS,
  FNOL_GET_PAYMENT_FORM_FIELDS_SUCCESS,
  FNOL_SET_DYNAMIC_FIELD_VALUE,
  FNOL_RESET_DYNAMIC_FORM,
  FNOL_SET_SELECTED_CODE_TYPE,
  FNOL_VALIDATE_CODE_FIELD,
} from './constants';

import {
  GET_BANK_SUCCESS,
  GETTING_BANK,
  GET_BANK_ERROR,
} from '../../FastCover/constants';

export const TUGO_DEFAULT_COUNTRY = { id: 39, name: 'Canada' };

// The initial state of the App
const initialState = fromJS({
  form: {
    abn: '',
    claimITC: 'false',
    nameOfBank: '',
    branch: '',
    bsbNumber: '',
    institutionNumber: '',
    accountNumber: '',
    accountHolder: '',
    registerForGSTPurpose: 'false',
    percentageOfGST: '',
    bsbCannotBeVerified: false,
    isBsbValid: false,
    otherInsurance: 'false',
    provideDetails: '',
    // V2 fields
    paymentTo: 'Member',
    country: {
      id: TUGO_DEFAULT_COUNTRY.id,
      label: TUGO_DEFAULT_COUNTRY.name,
      value: TUGO_DEFAULT_COUNTRY.name,
    },
    isCheckPayment: false,
    // Trawick-style bank fields (for non-Canada countries)
    bankTypeCode: 'Bank Code',
    bankCodeOrRoutingNumber: '',
    bank: '',
    bankAddress: '',
    bankSuburbOrCity: '',
    bankPostcode: '',
    bankBranch: '',
    bankAccountName: '',
    bankAccountNumber: '',
    swiftCode: '',
    iban: '',
    paymentTypeOptions: [],
    isValidate: false,
    // Check address fields
    paymentVia: 'EFT',
    title: '',
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: '',
    state: '',
    city: '',
    postalZipCode: '',
    mobile: '',
  },
  errors: [],
  dirty: false,
  bsbValidating: false,
  showBSBNotice: false,
  dynamicCodeVerificationFailed: false,
  dynamicPaymentCodeTypes: [],
  dynamicPaymentFormFields: [],
  dynamicFormValues: {},
  selectedCodeTypeId: null,
});

const initialRegisterForGstState = {
  form: {
    registerForGSTPurpose: 'false',
    abn: '',
    claimITC: 'false',
    percentageOfGST: '',
  },
};

const initialBankInfo = {
  form: {
    nameOfBank: '',
    branch: '',
    institutionNumber: '',
  },
};

const initialAddress = {
  form: {
    addressLine1: '',
    addressLine2: '',
    firstName: '',
    mobile: '',
    lastName: '',
    title: '',
    state: '',
    country: null,
    postalZipCode: '',
    city: '',
  },
};

const initialTugoBankFields = {
  form: {
    // Reset Canada bank fields
    nameOfBank: '',
    branch: '',
    bsbNumber: '',
    institutionNumber: '',
    accountNumber: '',
    accountHolder: '',
    bsbCannotBeVerified: false,
    isBsbValid: false,
    // Reset Trawick bank fields
    bankTypeCode: 'Bank Code',
    bankCodeOrRoutingNumber: '',
    bank: '',
    bankAddress: '',
    bankSuburbOrCity: '',
    bankPostcode: '',
    bankBranch: '',
    bankAccountName: '',
    bankAccountNumber: '',
    swiftCode: '',
    iban: '',
    isValidate: false,
  },
};

function stepAppsureBankDetailsReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      if (properties[1] === 'bsbCannotBeVerified' && !action.value) {
        return state.mergeDeep(initialBankInfo).setIn(properties, action.value);
      }
      return state.setIn(properties, action.value);
    case LOAD:
      if (action.payload) {
        return initialState.merge({
          form: action.payload,
          errors: [],
          dynamicFormValues: fromJS(action.payload.dynamicFormValues || {}),
          dynamicPaymentFormFields: fromJS(action.payload.dynamicPaymentFormFields || []),
        });
      }
      return initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_REGISTER_GST_STATE:
      return state.mergeDeep(initialRegisterForGstState);
    case GET_BANK_SUCCESS:
      return state.mergeDeep({ form: action.bankInfo, bsbValidating: false });
    case GETTING_BANK:
      return state.merge({ bsbValidating: action.value });
    case GET_BANK_ERROR:
      return state.merge({ showBSBNotice: true, dynamicCodeVerificationFailed: true });
    case FNOL_VALIDATE_CODE_FIELD:
      return state.set('dynamicCodeVerificationFailed', false);
    case CLOSE_BSB_NOTICE:
      return state.merge({ showBSBNotice: false });
    case RESET_TUGO_BANK_FIELDS:
      return state.mergeDeep(initialTugoBankFields);
    case RESET_ADDRESS:
      return state.mergeDeep(initialAddress);
    case FNOL_GET_PAYMENT_CODE_TYPES_SUCCESS:
      return state
        .set('dynamicPaymentCodeTypes', fromJS(action.data || []))
        .set('selectedCodeTypeId', action.data && action.data.length > 0 ? action.data[0].id : null);
    case FNOL_GET_PAYMENT_FORM_FIELDS_SUCCESS:
      return state
        .set('dynamicPaymentFormFields', fromJS(action.data || []))
        .set('dynamicFormValues', fromJS({}));
    case FNOL_SET_DYNAMIC_FIELD_VALUE:
      if (action.fieldName === 'BankBranchCode') {
        return state
          .setIn(['dynamicFormValues', action.fieldName], action.value)
          .set('dynamicCodeVerificationFailed', false);
      }
      return state.setIn(['dynamicFormValues', action.fieldName], action.value);
    case FNOL_SET_SELECTED_CODE_TYPE:
      return state.set('selectedCodeTypeId', action.codeTypeId);
    case FNOL_RESET_DYNAMIC_FORM:
      return state
        .set('dynamicPaymentCodeTypes', fromJS([]))
        .set('dynamicPaymentFormFields', fromJS([]))
        .set('dynamicFormValues', fromJS({}))
        .set('selectedCodeTypeId', null)
        .set('dynamicCodeVerificationFailed', false);
    default:
      return state;
  }
}

export default stepAppsureBankDetailsReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/reducer.js